<template>
    <div>
        <ul class="SideMenu">
            <li class="SideMenu-item" @click="jumpMenuBook">
                <img src="../assets/img/book.png">
                <p>{{getLabel('SIDE_MENU_BOOK')}}</p>
            </li>
            <li class="SideMenu-item" @click="jumpMenuGuide">
                <img src="../assets/img/guide.png">
                <p>{{getLabel('SIDE_MENU_GUIDE')}}</p>
            </li>
            <li class="SideMenu-item" @click="jumpMenuQA">
                <img src="../assets/img/qa.png">
                <p>{{getLabel('SIDE_MENU_QA')}}</p>
            </li>
            <li class="SideMenu-item" v-if="language !== 'zh' && charge_type === 1" @click="jumpMenuVISA">
                <img src="../assets/img/invite.png">
                <p>{{getLabel('SIDE_MENU_VISA')}}</p>
            </li>
        </ul>
        <a-modal
                id="visaDialog"
                v-model="visible"
                :title="null"
                :footer="null"
                :closable="false"
                :centered="true"
        >
            <p class="title" style="text-align: center;font-size: 1.5em;font-weight: bold;">
              NOTICE
            </p>
            <p class="content" style="margin: 15px 0;">
                <template v-if="not_finish_information">
                    Please fill in the basic information before downloading the
                    invitation letter for VISA application.
                </template>
                <template v-else>
                    Different embassies and consulates may have different requirements for the invitation letter.
                    <span style="font-weight: bold;color: #000;">Please check the downloaded letter carefully.</span>
                    If it does not meet the requirements of the local embassy or consulate, please contact us by email (shanghaiforum@fudan.edu.cn) and we will issue a new invitation letter within two working days.
                </template>
            </p>
            <p class="footer" style="display: flex; justify-content: center;">
                <a-button @click="close" style="width:100px;margin-right: 20px;">Cancel</a-button>
                <a-button style="width: 100px;" type="primary" v-if="not_finish_information" @click="goInformation">OK</a-button>
                <a-button style="width: 100px;" type="primary" v-else @click="downLoad">Download</a-button>
            </p>
        </a-modal>
    </div>
</template>

<script>
    import { Modal } from 'ant-design-vue';
    import Language from '../util/language';
    import {mapState, mapGetters} from "vuex";

    export default {
        created() {
            this.$store.dispatch('protocol/getVisaDownLoadUrl');
        },
        data() {
            return {
                visible: false
            }
        },
        computed: {
            ...mapState({
                language: state => state.main.language,
                charge_type: state => state.main.currentUser.charge_type, // 费用类型，1：公费 2：自费 3：分论坛
                VISA_URL: state => state.protocol.VISA_URL
            }),
            ...mapGetters('main', {
                not_finish_information: 'not_finish_information'
            })
        },
        methods: {
            // 获取描述
            getLabel: function (key) {
                return Language(this.language, key);
            },
            // 查看会议手册
            jumpMenuBook: function () {
                if(this.language === 'zh') {
                    window.open('https://shanghaiforum.fudan.edu.cn/b5/a3/c19378a767395/page.htm');
                } else {
                    window.open('https://shanghaiforum.fudan.edu.cn/forumen/b5/a6/c19060a767398/page.htm');
                }
            },
            // 查看会议指南
            jumpMenuGuide: function () {
                if(this.language === 'zh') {
                    window.open('https://shanghaiforum.fudan.edu.cn/b5/a2/c19378a767394/page.htm');
                } else {
                    window.open('https://shanghaiforum.fudan.edu.cn/forumen/b5/a5/c19060a767397/page.htm');
                }
            },
            // 查看Q&A
            jumpMenuQA: function () {
                if(this.language === 'zh') {
                    window.open('https://shanghaiforum.fudan.edu.cn/b7/99/c19378a767897/page.htm');
                } else {
                    window.open('https://shanghaiforum.fudan.edu.cn/forumen/b7/9a/c19060a767898/page.htm');
                }
            },
            // 查看VISA邀请函
            jumpMenuVISA: function () {
                this.visible = true;
            },
            // 补充信息
            goInformation() {
                this.close();
                this.$router.push(`information`);
            },
            // 关闭VISA提示弹窗
            close() {
                this.visible = false;
            },
            // 下载pdf
            downLoad() {
                this.close();
                // 通过接口获取地址
                window.open(this.VISA_URL);
            }
        }
    }
</script>

<style lang="less">
    .SideMenu {
        position: fixed;
        right: 0;
        top: 215px;
        width: 100px;
        background: #FFF;
        border: 1px solid #00A0ED;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        &-item {
            cursor: pointer;
            text-align: center;
            padding: 8px;
            border-bottom: 1px solid #00A0ED;
            &:nth-last-child(1) {
                border-bottom: none;
            }
            &:hover {
                color: #00A0ED;
            }
            img {
                width: 40px;
                height: auto;
                margin: 5px;
            }
        }

    }
</style>
